import React, {PureComponent} from "react";
import ReactDOM from "react-dom";

interface PortalProps {
    container: HTMLElement;
}

export default class Portal extends PureComponent<PortalProps> {
    private readonly element: HTMLDivElement;

    constructor(props: PortalProps) {
        super(props);

        this.element = document.createElement('div');
    }

    componentDidMount() {
        this.props.container.appendChild(this.element);
    }

    componentWillUnmount() {
        this.props.container.removeChild(this.element);
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.element,
        );
    }
}